import { ClientIntegrationPlatformConfig } from './platform-config.slice';

interface AccountLookup {
  accountId: string;
  id: string;
}

interface Filter {
  field: string;
  operator: string;
  value: any;
}

interface PlatformConfig {
  id: string;
  filters?: Filter[];
}

export function mapAccountsAndConfigs(
  accountIdLookups: AccountLookup[],
  platformConfigs: PlatformConfig[]
) {
  const accountIds = accountIdLookups.map(
    (accountLookup) => accountLookup.accountId
  );

  const mappedPlatformConfigs: ClientIntegrationPlatformConfig[] =
    accountIds.map((accountId, index) => {
      const lookup = accountIdLookups.find((l) => l.accountId === accountId);
      const config = platformConfigs.find((p) => p.id === lookup?.id);
      const firstFilter = config?.filters?.[0];

      return {
        configIdentifier: accountId,
        queryFilters: firstFilter
          ? [
              {
                id: index,
                field: firstFilter.field,
                operator: firstFilter.operator.toLowerCase(),
                value: firstFilter.value
              }
            ]
          : []
      };
    });

  return {
    mappedPlatformConfigs
  };
}
